import data from '@emoji-mart/data'
import classnames from 'classnames'
import { init } from 'emoji-mart'

import CUSTOM_EMOJIS from './customList'

import type { FC } from 'react'

init({ custom: CUSTOM_EMOJIS, data })

interface EmojiProps {
  className?: string
  name: string
}

const Emoji: FC<EmojiProps> = ({ className, name }) => (
  /* @ts-ignore custom types and TS are not friends */
  <em-emoji
    id={name.startsWith(':') ? undefined : name}
    class={classnames('inline-flex items-center *:inline-flex *:items-center', className)}
    shortcodes={name.startsWith(':') ? name : undefined}
    size="1em"
  />
)

export default Emoji
